import { gql } from "@apollo/client";

export const GET_DAMAGE_MATRIX_COUNT = gql`{
    damageMatrixCount
}`